define(
    'viewmodels/secured/libraries/settings',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "viewmodels/secured/libraries/settings/folder/Library",
        "viewmodels/secured/libraries/settings/folder/FolderActions",
        "services/service.dialog"
    ],
    function (app, ViewModel, dataProvider, i19n, Library, FolderActions, dialogService) {
        var $grid = null;
        var grid = null;

        var vm = new ViewModel(
        {
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,

            selectedFolderId: ko.observable(null),
            folders: ko.observable(),

            name: ko.observable(''),
            isTemplateSource: ko.observable(false),
            
            repositoryId: ko.observable(),
            isDisabled: ko.observable(false),
            
            isTemplateVisible: ko.observable(true),
            isFolderVisible: ko.observable(true),
            isAddDocuments: ko.observable(false),
            _loadFormDataResult: null,
            docWin: {
                fid: null,
                windowtitle: i19n.to.adddocuments,
                title: '',                
                exceptList: [],
                show: {},
                addDocuments: function (data) {
                    data = _.map(data, function (value, key) {
                        return { documentId: value };
                    });

                    dataProvider
                    .templatedocuments
                    .addDocuments(vm.selectedFolderId(), data)
                    .done(function (data) {
                        grid.dataSource.read();
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                    });
                }
            }
        });

        vm.activate = function () {

            vm.isTemplateVisible(true);
            vm.isFolderVisible(true);

            vm.name.focus = ko.observable(false);
            vm.name.isUpdating = ko.observable(false);
            vm.name.isUpdated = ko.observable(false);
            vm.name.old = '';

            vm.isTemplateSource.isUpdating = ko.observable(false);
            vm.isTemplateSource.isUpdated = ko.observable(false);
            vm.isTemplateSource.old = null;
            
            if (grid) {
                vm.selectedFolderId(null);

                //grid.dataSource.read();
            }
            
            return loadFormData()
            .done(function (data) {
                vm._loadFormDataResult = data;
            })
            .fail(function (e) {
                console.error(e);
            });
        };
        vm.attached = function () {
            //$combo = $("#repositories");

            //combo = $combo.kendoDropDownList({
            //    dataTextField: "text",
            //    dataValueField: "value",
            //    optionLabel: i19n.to.selectarepository,
            //    dataSource: {
            //        transport: {
            //            read: function (callbacks) {
            //                callbacks.success([{ text: 'Default Cloud', value: '1' }]);
            //            }
            //        }
            //    }
            //}).data("kendoDropDownList");

            buildGrid();

            $("#library-name").off();
            $("#library-name").on("keypress",function (e) {
                if (e.which == 13) {
                    _updateName($(this).val());
                }
            });
            $("#library-name").on("blur", function () {
                _updateName($("#library-name").val());
            });            

            var data = vm._loadFormDataResult;

            if (data.listId != null) {
                var library = new Library(vm.id, data.libraryTemplates[0].id, data.name, FolderActions, function (folder) {
                    vm.selectedFolderId(!folder ? null : folder.id);

                    if (grid) {
                        grid.dataSource.read();
                    }
                });

                vm.folders(library);

                vm.folders().loadTree()
                .done(function (d) {

                });
            }

            function _updateName(name) {
                if (!name || name.trim().toLowerCase() == vm.name.old.trim().toLowerCase())
                    return;

                var validator = $("#libraries-settings").kendoValidator().data("kendoValidator");
                if (validator.validate()) {
                    vm.name.isUpdating(true);

                    updateSettings(name, vm.isDisabled(), vm.repositoryId(), vm.isTemplateSource());
                }
            }
        };
        vm.saveClick = function () {

            var validator = $("#libraries-settings").kendoValidator().data("kendoValidator");

            if (validator.validate()) {
                updateSettings(vm.name(), vm.isDisabled(), vm.repositoryId(), vm.isTemplateSource());
            }
        };
        vm.cancelClick = function () {

            loadFormData();
        };
        vm.addDocumentsClick = function () {

            vm.docWin.fid = vm.id;
            vm.docWin.title = vm.name();

            vm.docWin.show();
        };
        vm.createFolderShowClick = function () {
            vm.isFolderVisible(true);

            buildGrid();            
        };

        function buildGrid() {
            $grid = $("#settingsdocument-grid" + vm.id);

            var columns = [
                { field: "id", hidden: true },
                { field: "icon", title: ' ', width: 26, template: '<i class="#:icon#"></i>' },
                { field: "docIdVersion", title: i19n.to.docidversion, width: 110 },
                { field: "title", title: i19n.to.title },
                {
                    command: [
                        { name: "destroy", text: i19n.to.remove }
                    ],
                    title: "&nbsp;",
                    width: "110px"
                }
            ];
           
            grid = $grid.kendoGrid({
                dataSource: getGridDataSource(),
                resizable: true,
                reorderable: true,
                sortable: true,
                columns: columns,
                scrollable: { virtual: true },
                editable: { mode: "inline", confirmation: false },
                remove: null
            }).data("kendoGrid");

            function getGridDataSource() {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            if (vm.selectedFolderId() == null) {
                                callbacks.success([]);

                                return;
                            }

                            updateExceptList(callbacks);
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.title + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    grid.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    dataProvider
                                    .templatedocuments
                                    .removeDocuments(callbacks.data.folderId, [{ documentId: callbacks.data.id }])
                                    .done(function (result) {
                                        updateExceptList(callbacks);
                                    })
                                    .fail(function (e) {
                                        grid.cancelChanges();
                                        e.stopPropagation = true;

                                        callbacks.error(e.error);
                                        console.error(e);
                                    });
                                }
                            });
                        }
                    },
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                folderId: { type: "string" },
                                id: { type: "string" },
                                docIdVersion: { type: "string" },
                                title: { type: "string" }
                            }
                        }
                    },
                    pageSize: 1024
                });
            }
        }

        return vm;

        function updateExceptList(callbacks) {
            dataProvider
            .templatedocuments
            .getDocuments(vm.selectedFolderId())
            .done(function (data) {
                data = data || [];

                vm.isAddDocuments(true);

                var data = _.map(data, function (itm) {
                    return {
                        icon: getDocumentIcon(itm.extension),
                        folderId: vm.selectedFolderId(),
                        id: itm.documentId,
                        docIdVersion: itm.docIdVersion,
                        title: itm.title
                    };
                });

                vm.docWin.exceptList = _.map(data, function (itm) { return { id: itm.id }; });

                if (callbacks != null) callbacks.success(data);
            })
            .fail(function (e) {
                vm.isAddDocuments(false);

                e.stopPropagation = true;                

                if (callbacks != null) callbacks.success([]);

                console.error(e);
            });
        }
        function getDocumentIcon(extension) {
            if (extension == 'doc' || extension == 'docx')
                return 'icon icon-file-word application-type';
            if (extension == 'xls' || extension == 'xlsx')
                return 'icon icon-file-excel application-type';
            if (extension == 'pdf')
                return 'icon icon-file-pdf application-type';
            if (extension == 'zip')
                return 'icon icon-file-zip application-type';
            if (extension == 'htm')
                return 'icon icon-envelope-alt application-type';

            return 'icon icon-file application-type';
        }
        function setupSubscribeEvents() {
            vm.name.focus.subscribe(function (newvalue) {
                if (!newvalue) {
                    setTimeout(function () {
                        if (!vm.name.isUpdating()) { vm.name.isUpdated(false); }
                    }, 1500);
                } else {
                    vm.name.isUpdating(false);
                    vm.name.isUpdated(false);
                }
            });
            
            //vm.isDisabled.subscribe(function (newvalue) {
            //    updateSettings(vm.name(), newvalue, vm.repositoryId(), vm.isTemplateSource());
            //});            
            //vm.isDisabled.extend({ rateLimit: 1000 });
            
            //vm.repositoryId.subscribe(function (newvalue) {
            //    updateSettings(vm.name(), vm.isDisabled(), newvalue, vm.isTemplateSource());
            //});
            //vm.repositoryId.extend({ rateLimit: 1000 });                        

            vm.isTemplateSource.subscribe(function (value) {
                if (vm.isTemplateSource.isUpdating())
                    return;

                vm.isTemplateSource.old = value;
            }, this, "beforeChange");
            vm.isTemplateSource.subscribe(function (newvalue) {
                if (vm.isTemplateSource.isUpdating())
                    return;

                if (vm.isTemplateSource.old != newvalue) {
                    updateSettings(vm.name(), vm.isDisabled(), vm.repositoryId(), newvalue);
                }
            });
            vm.isTemplateSource.extend({ rateLimit: 1000 });
        }
        function updateSettings(name, isDisabled, repositoryId, isTemplateSource) {
            name = name.trim();

            dataProvider.libraries
            .updateSettings(vm.id, name, isDisabled, repositoryId, isTemplateSource)
            .done(function (data) {
                if (vm.name.isUpdating()) {
                    vm.name(name);
                    vm.name.old = name;
                    vm.name.isUpdating(false);
                    vm.name.isUpdated(true);

                    vm.reload(vm.id, name);
                }
                if (vm.isTemplateSource.isUpdating()) {
                    vm.isTemplateSource(isTemplateSource);
                    vm.isTemplateSource.old = isTemplateSource;
                    vm.isTemplateSource.isUpdating(false);
                    vm.isTemplateSource.isUpdated(true);
                }
            })
            .fail(function (e) {
                console.error(e);
            });
        }
        function loadFormData() {
            var d = $.Deferred();
            
            dataProvider.libraries
            .getSettings(vm.id)
            .done(function (data) {
                data.libraryTemplates = _.sortBy(data.libraryTemplates, function (itm) { return itm ? itm.name : ""; });                

                vm.name.isUpdated(false);
                vm.name.isUpdating(true);
                vm.name(data.name);
                vm.name.old = data.name;
                vm.name.isUpdating(false);
                
                vm.isTemplateSource.isUpdated(false);
                vm.isTemplateSource.isUpdating(true);
                vm.isTemplateSource(data.isTemplateSource);
                vm.isTemplateSource.old = data.isTemplateSource;
                vm.isTemplateSource.isUpdating(false);

                //vm.isDisabled(data.isDisabled);
                //vm.repositoryId(data.repositoryId);
               
                vm.isTemplateVisible(data.listId != null);        

                if (!grid) {
                    setupSubscribeEvents();
                }

                d.resolve(data);
            })
            .fail(function (e) {
                console.error(e);

                d.reject(data);
            });

            return d.promise();
        }
    }
);
